import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { SectionHeader } from '@/pages/CompanyReport/components/Overview/components/SectionHeader';

export const SummarySection = styled(Section)`
  position: relative;
  min-height: 360px;

  h3 {
    margin: ${({ theme }) => theme.x1spacePx}px 0;
  }

  ${media.mdUp`
    padding-top: ${({ theme }) => theme.x3space}rem;
    padding-bottom: ${({ theme }) => theme.x3space}rem;
  `}
`;

export const RiskRewardWrapper = styled('div')`
  ul {
    list-style: disc;
    padding: 0 ${({ theme }) => theme.x3spacePx}px 0
      ${({ theme }) => (theme.x3space - 0.4) * 10}px;
    margin-bottom: 0;
    > li {
      margin-bottom: ${({ theme }) => theme.x1spacePx / 2}px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  ${media.smUp`
    min-height: 240px;
  `};
`;

export const SnowflakeChart = styled('div')`
  max-width: 200px;
  margin: 0 0 0 auto;
  ${media.smUp`
    width: 200px;
  `}
  ${media.mdUp`
    width: 280px;
    max-width: 280px;
  `};
`;

export const OverviewSectionHeader = styled(SectionHeader)`
  ${media.mdDown`
    ${({ theme }) => theme.typography.smallStrong};
  `};
`;

export const SnowflakeDescription = styled('div')`
  padding-left: ${({ theme }) => theme.x1spacePx}px;
  text-wrap: pretty;

  ${media.smUp`
    padding-left: 0;
  `};
`;

export const SnowflakeTitle = styled('p')`
  margin-bottom: 0;
  opacity: 0.7;
  ${({ theme }) => theme.typography.xSmallStrong};
`;

export const SnowflakeCaption = styled('p')`
  margin-bottom: 0;
  opacity: 0.5;
  ${({ theme }) => theme.typography.xSmall};
`;
